import Client from "./client";

// Unauthenticated, fire-and-forget - see components/RouteAnalytics.js and
// api/routes/analytics.js. No accessToken: this fires on the landing page
// and sign-up before anyone is signed in, and the beacon doesn't identify a
// visitor at all, signed in or not.

export const SendPageview = ({path, referrerHost}) => {
    return new Promise((resolve, reject) => {
        Client.post('/api/public/analytics/pageview', {path, referrerHost}).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || {error: "Something went wrong."});
        })
    })
}
